// PatientRegistrationDialogs.jsx
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';

export function AdditionalServicesDialog({ open, onOpenChange, items = [] }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-h-[90vh] overflow-y-auto mt-4">
        <DialogBody>
          <DialogTitle className="text-black  text-left">
            Papildomos gydytojo teikiamos paslaugos
          </DialogTitle>
          <Label className="text-sm text-muted-foreground font-normal  text-left">
            Prašome susipažinti su papildomomis paslaugomis, kurios gali būti
            reikalingos jūsų vizito metu. Jų kaina neįeina į pagrindinės
            paslaugos kainą.
          </Label>

          <Separator className={'my-2'} />
          <ul className="space-y-2">
            {items.map((it, idx) => (
              <li
                key={idx}
                className="grid grid-cols-[1fr_auto] items-center gap-4"
              >
                <span className="text-sm leading-5 text-left">{it.title}</span>
                <span className="text-sm font-medium text-[#1F4B81] text-right">
                  {it.price} €
                </span>
              </li>
            ))}
          </ul>

          <Separator className={'my-2'} />
          <a
            href="https://affidea.lt/lt/kainos/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#1F4B81] underline underline-offset-2 text-sm text-left"
          >
            Susipažinti su visomis klinikos kainomis.
          </a>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
